import { useRouter } from 'next/router';

import { SEARCH_QS } from '../constants';

/** Extrait les params de recherche du routeur */
export const useSearchParams = () => {
  const { query } = useRouter();
  const term = String(query[SEARCH_QS.TERM] ?? '');
  const source = String(query[SEARCH_QS.SOURCE] ?? '');
  const searchID = String(query[SEARCH_QS.SEARCHID] ?? '');
  return { term, source, searchID };
};
